<template>
  <div class="main-row">
    <div class="left-column">
      <div class="infobox">
        <h3>Brukervilkår</h3>
        <p>
          Opplysningene du legger inn her, blir brukt til å regne ut din forventede lønn, og for å lage lønnsstatistikk for ingeniører i Norge. <br>
          Informasjonen du legger inn er ikke synlig for andre.
        </p>
        <v-checkbox
          :label="'Jeg godtar vilkårene'"
          v-model="terms_accepted"
          color="primary"
        ></v-checkbox>
      </div>
      <v-icon  v-if="terms_accepted" class="display-on-mobile">arrow_downward</v-icon>
    </div>

    <div class="right-column">
      <div class="mobile-padding">
          <p v-if="!terms_accepted">Velkommen. Først må du godta vilkårene</p>
          <p v-else>Verifiser deg, så vet vi at du er en ekte person.</p>
      </div>
      <v-icon v-if="terms_accepted">arrow_downward</v-icon>

      <div style="width: 70%;" v-if="terms_accepted" @keyup.enter="signUpEmailLink">
        <v-text-field
          v-model="email"
          type="email"
          label="Fyll inn din e-post"
          required
        ></v-text-field>
        <v-btn v-if="!emailSent" @click="signUpEmailLink" color="primary" block>Verifiser</v-btn>
      </div>
      <div class="mail-success" v-if="emailSent"><p>Vi har sendt deg en epost. Følg lenken i denne for å gå videre.</p></div>
      <div class="mail-error" v-if="emailError"><p>Vi klarte ikke å sende deg en epost. Er du sikker på at du skrev inn riktig?</p></div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    db: Object,
    auth: Object
  },
  data () {
    return {
      email: "",
      actionCodeSettings: {
        // url: "http://localhost:8080/#/email-landing",
        url: 'https://' + window.location.hostname + window.location.pathname + window.location.search + '#/email-landing',
        handleCodeInApp: true,
      },
      emailSent: false,
      emailError: false,
      terms_accepted: false
    }
  },
  methods: {
    signUpEmailLink: function() {
      this.auth.sendSignInLinkToEmail(this.email, this.actionCodeSettings)
        .then(() => {
          // The link was successfully sent. Inform the user.
          // Save the email locally so you don't need to ask the user for it again
          // if they open the link on the same device.
          this.emailSent = true
          window.localStorage.setItem('emailForSignIn', this.email);
        })
        .catch((error) => {
          this.emailError = true
          // Some error occurred, you can inspect the code: error.code
          console.log(error.code)
        });
    }
  }  
}
</script>





// WEBPACK FOOTER //
// src/components/Login.vue